import React from "react";
import { Link } from "react-router-dom";
import Navbar from "../components/Navbar";
import { InvoicesView } from "../components/InvoicesView";
import { EmailGate } from "../components/market/EmailGate";
import { useMarketMe } from "./market/MarketHome";
import { useAuth } from "../lib/auth";

// Customer dashboard for anyone who paid: shoppers, gift givers and guests. Signed-in users or email-code access.
export default function AccountOrdersPage() {
  const [me, reloadMe] = useMarketMe();
  const { user } = useAuth();
  return (
    <div className="min-h-screen bg-[var(--bg)]">
      <Navbar />
      <div className="container-wide px-5 md:px-12 pt-28 pb-20 max-w-5xl">
        <p className="font-script text-[var(--gold)] text-3xl">Your account</p>
        <h1 className="font-serif font-light text-4xl sm:text-5xl mb-2" data-testid="account-orders-title">Orders & invoices</h1>
        <p className="text-[var(--muted)] mb-8">Marketplace orders, registry and live gifts, and plan payments, each with a PDF receipt.{me?.email ? ` Signed in as ${me.email}.` : ""}</p>
        <div className="flex flex-wrap gap-2 mb-8">
          <Link to="/market" className="btn-outline-gold !py-2" data-testid="account-orders-shop">Shop the marketplace</Link>
          <Link to="/market/inbox" className="btn-outline-gold !py-2" data-testid="account-orders-messages">Message sellers</Link>
          {user?.plan_selected && <Link to="/dashboard" className="btn-gold !py-2" data-testid="account-orders-dashboard">Go to my dashboard</Link>}
          {user && !user.plan_selected && <Link to="/choose-plan" className="btn-gold !py-2" data-testid="account-orders-plan">Plan your own wedding</Link>}
        </div>
        {me === null && <EmailGate onDone={reloadMe} />}
        {me && <InvoicesView />}
      </div>
    </div>
  );
}
